export class LoginState {
	loginPosterUrl: string;
}
